import React, { useState } from "react";
import { Collapse } from "@mui/material";
import { translate } from "../../../../../../common/providers";
import { IconComponent, icon } from "../../../../../../common/components";
import styles from "./InlineNotificationPreview.module.css";

export default function InlineNotificationPreview({ data }) {
	const { subject, documents, distributionType, summary, territoryName, recipientEmails } = data;

	const [documentsExpanded, setDocumentsExpanded] = useState(true);
	const [emailsExpanded, setEmailsExpanded] = useState(true);

	return (
		<div className={styles.container}>
			<div className={styles.section}>
				<div
					className={styles.sectionHeader}
					role="button"
					tabIndex={0}
					onClick={() => setDocumentsExpanded(!documentsExpanded)}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							setDocumentsExpanded(!documentsExpanded);
						}
					}}
				>
					<span className={styles.label}>
						{translate("document-center.distribution-notification.documents.label")}
					</span>
					<IconComponent
						className={`${styles.chevron} ${documentsExpanded ? styles.chevronRotated : ""}`}
						icon={icon.faChevronUp}
					/>
				</div>
				<Collapse in={documentsExpanded}>
					<div className={styles.documentsList}>
						{documents.map((doc) => (
							<div key={doc.id || doc} className={styles.documentItem}>
								{doc.label || doc.name || doc}
							</div>
						))}
					</div>
				</Collapse>
			</div>

			<div className={styles.section}>
				<span className={styles.label}>
					{translate("document-center.distribution-notification.territory.label")}
				</span>
				<div className={styles.value}>{territoryName}</div>
			</div>

			<div className={styles.section}>
				<div
					className={styles.sectionHeader}
					role="button"
					tabIndex={0}
					onClick={() => setEmailsExpanded(!emailsExpanded)}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							setEmailsExpanded(!emailsExpanded);
						}
					}}
				>
					<span className={styles.label}>
						{translate("document-center.distribution-notification.emails.label")}
					</span>
					<IconComponent
						className={`${styles.chevron} ${emailsExpanded ? styles.chevronRotated : ""}`}
						icon={icon.faChevronUp}
					/>
				</div>
				<Collapse in={emailsExpanded}>
					<div className={styles.emailsList}>
						{recipientEmails.length > 0 ? (
							recipientEmails.map((email) => (
								<div key={email} className={styles.emailItem}>
									{email}
								</div>
							))
						) : (
							<span className={styles.empty}>-</span>
						)}
					</div>
				</Collapse>
			</div>

			<div className={styles.section}>
				<span className={styles.label}>
					{translate("document-center.distribution-notification.subject.label")}
				</span>
				<div className={styles.valueBlock}>{subject}</div>
			</div>

			<div className={styles.section}>
				<span className={styles.label}>
					{translate("document-center.distribution-notification.distribution-type.label")}
				</span>
				<div className={styles.value}>{distributionType}</div>
			</div>

			<div className={styles.section}>
				<span className={styles.label}>
					{translate("document-center.distribution-notification.summary.label")}
				</span>
				<div className={styles.value}>{summary}</div>
			</div>
		</div>
	);
}
